module.exports = __webpack_public_path__ + "img/bow-long-arrow.a04688cd.svg";